import React, { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [isAuthed, setIsAuthed] = useState(null); // null unknown, true, false

  useEffect(() => {
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      return; // AuthCallback will exchange the OAuth session first
    }
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setIsAuthed(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        setIsAuthed(true);
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setIsAuthed(false);
      });
  }, []);

  const applyAuth = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    setIsAuthed(true);
  };

  const requestMagicLink = async (email) => {
    const { data } = await api.post("/auth/request-magic-link", { email, origin: window.location.origin });
    return data;
  };

  const verifyMagicLink = async (token) => {
    const { data } = await api.post("/auth/verify", { token });
    applyAuth(data.token, data.user);
    return data.user;
  };

  const googleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google-session", { session_id: sessionId });
    applyAuth(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
    setIsAuthed(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, isAuthed, requestMagicLink, verifyMagicLink, googleSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
